import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "react-toastify";
import { MdOutlineLock } from "react-icons/md";
import { _changePassword } from "Services/api";
import InputField from "components/fields/InputField";
import SectionCard from "components/card/SectionCard";
import {
  ChangePasswordFormFieldsName,
  changePasswordFormDefaultValues,
  changePasswordFormSchema,
} from "constants/react-hook-form";

const SubmitButton = ({ loading, children }) => (
  <button
    type="submit"
    className="flex w-full items-center justify-center rounded-xl bg-brand-500 px-4 py-3 font-medium text-white shadow-sm transition hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
    disabled={loading}
  >
    {loading ? "Saving..." : children}
  </button>
);

const Settings = () => {
  const accessToken = sessionStorage.getItem("VendorToken");
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const passwordForm = useForm({
    resolver: zodResolver(changePasswordFormSchema),
    defaultValues: changePasswordFormDefaultValues,
  });

  const handlePasswordSubmit = async (data) => {
    setIsChangingPassword(true);
    try {
      const body = {
        current_password: data[ChangePasswordFormFieldsName.CURRENT_PASSWORD],
        new_password: data[ChangePasswordFormFieldsName.NEW_PASSWORD],
      };

      const response = await _changePassword({ body, accessToken });
      toast.success(response.message || "Password updated successfully.");
      passwordForm.reset(changePasswordFormDefaultValues);
    } catch (error) {
      toast.error(error.response?.data?.message || "Could not update password.");
    } finally {
      setIsChangingPassword(false);
    }
  };

  return (
    <div className="flex w-full flex-col gap-5">
      <SectionCard
        title="Account Settings"
        description="Change your account password."
        icon={<MdOutlineLock />}
      >
        <form
          onSubmit={passwordForm.handleSubmit(handlePasswordSubmit)}
          className="space-y-4"
          noValidate
        >
          <InputField
            control={passwordForm.control}
            name={ChangePasswordFormFieldsName.CURRENT_PASSWORD}
            id="currentPassword"
            label="Current Password"
            type="password"
          />
          <InputField
            control={passwordForm.control}
            name={ChangePasswordFormFieldsName.NEW_PASSWORD}
            id="newPassword"
            label="New Password"
            type="password"
          />
          <InputField
            control={passwordForm.control}
            name={ChangePasswordFormFieldsName.CONFIRM_PASSWORD}
            id="confirmPassword"
            label="Confirm Password"
            type="password"
          />
          <SubmitButton loading={isChangingPassword}>Update Password</SubmitButton>
        </form>
      </SectionCard>
    </div>
  );
};

export default Settings;
